/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Adminaccessrequired2Inputs */

const en_adminaccessrequired2 = /** @type {(inputs: Adminaccessrequired2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Admin access required`)
};

const de_adminaccessrequired2 = /** @type {(inputs: Adminaccessrequired2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Administratorzugriff erforderlich`)
};

/**
* | output |
* | --- |
* | "Admin access required" |
*
* @param {Adminaccessrequired2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const adminaccessrequired2 = /** @type {((inputs?: Adminaccessrequired2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Adminaccessrequired2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_adminaccessrequired2(inputs)
	return de_adminaccessrequired2(inputs)
});
export { adminaccessrequired2 as "adminAccessRequired" }